import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Storage } from './../../app/models/storage';
import { Plate } from '../models/plate';
import { Observable } from 'rxjs';
import { map, timeout } from 'rxjs/operators';
import { BBResponseContainer } from '../carrier/response-container';

@Injectable({
  providedIn: 'root'
})
export class MaStorageService {
  readonly timeoutForExcelSave = 30000;

  constructor(private httpClient: HttpClient) { }

  // MA_STORAGE_API=environment.BB_SAMPLE_PROCESSING_API;

  fetchAllStorage(labID: string, skip: Number, limit: Number, active: boolean){
    let url;
    if (active)
      url = environment.BB_STORAGE_URL+'storagelist/'+labID+'/'+skip+'/'+limit+'?active=true';
    else
      url = environment.BB_STORAGE_URL+'storagelist/'+labID+'/'+skip+'/'+limit;
    return this.httpClient.get<any>(url);
  }

  saveStorageDetails(storageObj : Storage){
      let url =  environment.BB_STORAGE_URL+'addstorage';
      return this.httpClient.post(url,storageObj)
  }

  deleteStorageDetails(){
  } 

  searchStorageByPlate(labID: string, plateID: string){ 
    let url = environment.BB_STORAGE_URL+'getstoragebyplate/'+ labID+'/'+plateID;
    return this.httpClient.get<Storage>(url);
  }

  fetchActiveStorageLocations(labID : string, processStep: string = undefined){
    let url = environment.BB_STORAGE_URL+'activestoragelist/'+labID;
    if (processStep != undefined) {
      url+= '?processStep='+processStep;
    }
    return this.httpClient.get<any>(url);
  }

  editStorageDetails(storageObj : Storage, labID: string, storageName: string){
    let url = environment.BB_STORAGE_URL+'updatestorage/'+labID+'/'+storageName;
    return this.httpClient.put<Storage>(url, storageObj);
  }

  descriptionStorageDetails(descriptionStorageDetails : Storage){
    let url = environment.BB_STORAGE_URL+'getstorage'; 
    return this.httpClient.get<Storage>(url);
  }

  addPlateToStorage(data : any){
    let url = environment.BB_STORAGE_URL+'addplate';
    return this.httpClient.put<Storage>(url, data);
  }

  addMultiplePlatesToStorage(data : any){
    let url = environment.BB_STORAGE_URL+'addmultipleplates';
    return this.httpClient.put<any>(url, data);
  }

  removePlateFromStorage(data : any){
    let url = environment.BB_STORAGE_URL+'removeplate';
    return this.httpClient.put<any>(url, data);
  }

  removeMultiplePlatesFromStorage(data : any){
    let url = environment.BB_STORAGE_URL+'removemultipleplates';
    return this.httpClient.put<any>(url, data);
  }
  
  checkIfPlateExists(labId: String, plateID: String){
    let url = environment.BB_SAMPLE_PROCESSING_API+'checkPlateExists/'+labId+"/"+plateID;
    return this.httpClient.get<BBResponseContainer>(url).pipe(map(result => result.data as any))
  }

  markPlatesAsStorage(labid:string,data:any){
    let url = `${environment.BB_SAMPLE_PROCESSING_API}markPlatesAsStorage/${labid}`
    return this.httpClient.put<BBResponseContainer>(url,data).pipe(map(result => result.data as string))
  }

  restorePlatesFromStorage(labid:string,data: any){
    let url = `${environment.BB_SAMPLE_PROCESSING_API}restorePlatesFromStorage/${labid}`
    return this.httpClient.put<BBResponseContainer>(url,data).pipe(map(result => result.data as string))
  }

  getPlateDetails(labid:string,plateid:string){
    let url = `${environment.BB_SAMPLE_PROCESSING_API}plate/${labid}/${plateid}`
    return this.httpClient.get<BBResponseContainer>(url).pipe((map(result => result.data as Plate)))
  }

  getStorageListByPlateList(labId: string, plateIDs: string[]): Observable<BBResponseContainer> {
    let url = environment.BB_STORAGE_URL+'getStorageLists/'+labId;
    return this.httpClient.post<any>(url, plateIDs).pipe(timeout(environment.defaultTimeout));
  }

}
